export default __webpack_public_path__ + "static/Tek_Sensor-9c7b0fcd280f1e942fd4303c56635ddb.png";